import React from "react";
import {ModalPanel} from "@components/Modal2023";
import {IconAlertTriangleFilled} from "@tabler/icons-react";

export interface SavePresenzeError {
    idDip: number,
    message?: string,
}

export const ModalOnSavePresenzeError: React.FC<{ wasError: SavePresenzeError|null, onRollback: (id: number) => void, onReload: (id: number) => void }> = ({wasError, onRollback, onReload}) => {
    return <ModalPanel
        isOpen={!!wasError}
        header={<div className="flex flex-col space-y-2 mx-6 mb-10">
            <div className="mx-auto py-3"><span className="inline-flex text-red-600">
                        <IconAlertTriangleFilled className="h-10 w-10" aria-hidden="true"></IconAlertTriangleFilled>
                        <span className="ml-2 my-auto">Errore</span></span>
            </div>
            <div className="mx-auto">{wasError ? wasError.message : ''}</div>
        </div>}
        handleDismiss={() => onRollback(wasError!.idDip)}
        bgColor="bg-gray-50"
    >
        <div className="px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <button
                type="button"
                className="bg-red-600 ml-3 btnDanger"
                onClick={() => onReload(wasError!.idDip)}
            >Ricarica
            </button>
            <button
                type="button"
                className="btnDefault"
                onClick={() => onRollback(wasError!.idDip)}
            >Annulla modifiche
            </button>
        </div>
    </ModalPanel>
}